<template>
  <div class="view">
    <div style="height: 20vh;background: #e9c7a0;display: flex;">
      <img
          class="health_bg"
          src="../../assets/images/health_bg.png" alt="饮食图标"/>
      <div v-if="$route.query && $route.query.showTitle"
           style="margin-top: 3.5vh;margin-left: 3vw;height: 3vh;display: flex;align-items: center;"
           @click="$router.back()">
        <img src="../../assets/images/back.png" style="width: 3vh;height: 3vh">
        <span style="font-size: 3vh;font-weight: 700;color: #dc6666;text-align: left;vertical-align: top;">{{
            $route.meta && $route.meta.title || ''
          }}</span>
      </div>
    </div>

    <!-- 顶部头图与标题（左对齐、白底徽章） -->
    <header class="header" style="background: #e9c7a0;">
      <div class="header-title">您的健康解决方案</div>
      <div class="badge badge-white">{{ constitution.syndrome }}</div>
    </header>

    <div class="view_content_bg container" style="margin:0;padding-left: 3vw;padding-right: 3vw;background: #e9c7a0;">
      <!-- 饮食调养（图标在上，标题在下；右侧为“原则”气泡） -->
      <section class="card">
        <div class="card-hd">
          <div class="hd-left">
            <img class="icon" src="../../assets/images/diet.png" alt="饮食图标"/>
            <div class="card-title">饮食调养</div>
          </div>
          <div class="rule-bubble">
            {{ constitution.diet.rule }}
          </div>
        </div>

        <div class="card-bd">
          <div class="panel panel-aqua" v-if="constitution.diet.foods && constitution.diet.foods.length > 0">
            <div class="panel-title">推荐食物</div>
            <div class="panel-text">
              <div v-for="(it, i) in constitution.diet.foods" :key="i"><strong
                  class="kv-label">{{ it.label }}：</strong><span>{{ it.text }}</span><br/></div>
            </div>
          </div>

          <div class="panel panel-peach" v-if="constitution.diet.recipes && constitution.diet.recipes.length > 0">
            <div class="panel-title">食疗方案</div>
            <div class="panel-text">
              <div v-for="(it, i) in constitution.diet.recipes" :key="i"><strong
                  class="kv-label">{{ it.label }}：</strong><span>{{ it.text }}</span><br/></div>
            </div>
          </div>

          <div class="panel panel-pink panel-warning"
               v-if="constitution.diet.taboo && constitution.diet.taboo.length > 0">
            <div class="panel-title">饮食禁忌</div>
            <div class="panel-text" v-if="constitution.diet.taboo && constitution.diet.taboo.length > 0">
              <div v-for="(it, i) in constitution.diet.taboo" :key="i"><strong
                  class="kv-label">{{ it.label }}：</strong><span>{{ it.text }}</span><br/></div>
            </div>
            <div class="panel-text" v-else>
              {{ constitution.diet.tabooBlock }}
            </div>
            <img class="warn" src="../../assets/images/diet_warning.png" alt="!"/>
          </div>
        </div>
      </section>

      <!-- 运动保健（图标在上，标题在下；右侧为“原则”气泡） -->
      <section class="card">
        <div class="card-hd">
          <div class="hd-left">
            <img class="icon" src="../../assets/images/sport.png" alt="运动图标"/>
            <div class="card-title">运动保健</div>
          </div>
          <div class="rule-bubble">
            {{ constitution.sport.rule }}
          </div>
        </div>

        <div class="card-bd">
          <div class="sub-title">推荐运动</div>
          <div class="tags">
            <span class="tag" v-for="(item,index) in constitution.sport.tags" :key="index">{{ item }}</span>
          </div>
          <div class="note">{{ constitution.sport.note }}</div>
        </div>
      </section>

      <!-- 情志起居调养（图标与标题左右排列） -->
      <section class="card">
        <div class="card-hd card-hd--no-bubble">
          <div class="hd-left hd-left--row">
            <img class="icon" src="../../assets/images/emotion.png" alt="情志图标"/>
            <div class="card-title">情志起居调养</div>
          </div>
        </div>

        <div class="card-bd">
          <div class="panel panel-blue">
            <div class="panel-title">情志调养</div>
            <div class="panel-text">
              <div v-for="(it, i) in constitution.emotion.items" :key="i"><strong
                  class="kv-label">{{ it.label }}：</strong><span>{{ it.text }}</span><br/></div>
            </div>
          </div>

          <div class="panel panel-lavender">
            <div class="panel-title">起居调养</div>
            <div class="panel-text">
              <div v-for="(it, i) in constitution.lifestyle.items" :key="i"><strong
                  class="kv-label">{{ it.label }}：</strong><span>{{ it.text }}</span><br/></div>
            </div>
          </div>
        </div>
      </section>

      <div class="glossoscopyList">
        <div class="glossoscopytitle_one">
          <img alt="" class="glossoscopytex" src="../../assets/images/aijiu.png">
          <span class="glossoscopytitle">艾灸按摩</span>
        </div>

        <div v-for="(care,cares) in massage_health_care" :key="cares">
          <div class="explain">{{ care.bottom }}</div>
          <span class="fz24">{{ care.message }}</span>
          <!--              <div v-for="(item,itemvalue) in care.items" :key="itemvalue">-->
          <div v-if="care.photo||care.desc" class="Recuperation">
            <img v-if="care.photo" :src="care.photo" alt="">
            <!--                  <span class="pl30 fz28">{{ item.name }}<br/>-->
            <div class=" fz20" v-html="care.desc"/>
          </div>
          <!--              </div>-->
        </div>
      </div>

      <!-- 情志起居调养（图标与标题左右排列） -->
      <section class="card"
               style="display: flex;flex-direction: row;align-items: center;justify-content: center; margin-bottom: 10px;padding: 5px">
        <img class="icon" src="../../assets/images/health_remark.png"/>
        <div class="fz24" style="padding-top: 0;margin-left: 10px;font-weight: 500;color: black">
          {{ constitution.summary }}
        </div>
      </section>
    </div>


    <view_bottom></view_bottom>
  </div>
</template>

<script>
import view_bottom from '@/pages/healthy/view_bottom'
import axios from 'axios'


// 工具与解析函数
function normalize(text) {
  return (text || '')
      .replace(/\r\n/g, '\n')
      .replace(/\t/g, ' ')
      .replace(/[ ]{2,}/g, ' ')
      .replace(/\u3000/g, ' ')
      .trim();
}

function splitSections(text, titles) {
  const pattern = new RegExp(`(${titles.join('|')})[：:]\\s*`, 'g');
  const out = [];
  let m, lastIndex = 0, lastTitle = null;
  while ((m = pattern.exec(text)) !== null) {
    if (lastTitle) {
      const chunk = text.slice(lastIndex, m.index).trim();
      if (chunk) out.push({title: lastTitle, body: chunk});
    }
    lastTitle = m[1];
    lastIndex = pattern.lastIndex;
  }
  if (lastTitle) {
    const tail = text.slice(lastIndex).trim();
    out.push({title: lastTitle, body: tail});
  }
  return out;
}

// 从 body 中取 startLabel 到下一个 endLabels 之一的片段
function sliceBlock(body, startLabel, endLabels) {
  const reStart = new RegExp(`${startLabel}[：:]\\s*`);
  const m = reStart.exec(body);
  if (!m) return '';
  const start = m.index + m[0].length;
  let end = body.length;
  (endLabels || []).forEach(lbl => {
    const reEnd = new RegExp(`\\n${lbl}[：:]`); // 以换行+标签开头作为下一个区块
    const mm = reEnd.exec(body.slice(start));
    if (mm) {
      const idx = start + mm.index;
      if (idx < end) end = idx;
    }
  });
  return body.slice(start, end).trim();
}

// 解析若干行“子项：内容”
function parsePairs(linesText) {
  const lines = (linesText || '').split(/\n+/).map(s => s.trim()).filter(Boolean);
  const items = [];
  lines.forEach(line => {
    const m = line.match(/^(.+?)\s*[：:]\s*(.+)$/);
    if (m) items.push({label: m[1].trim(), text: m[2].trim()});
  });
  return items;
}

// 列表字符串拆成数组（逗号、顿号、全角顿号、空格、句号）
function splitList(str) {
  return (str || '')
      .replace(/[。.;；]$/, '')
      .split(/[、，,；;]\s*/).map(s => s.trim()).filter(Boolean);
}

// 各大段解析
function parseDiet(body) {
  const dietLabels = ['原则', '推荐食物', '食疗方案', '饮食禁忌'];
  const rule = sliceBlock(body, '原则', dietLabels.filter(x => x !== '原则')).replace(/\n+/g, ' ').trim();

  const foodsBlock = sliceBlock(body, '推荐食物', dietLabels.filter(x => x !== '推荐食物'));
  const foods = parsePairs(foodsBlock); // e.g. [{label:'蔬菜类', text:'...'}, ...]
  const foodsLines = foods.map(i => `${i.label}：${i.text}`);

  const recipeBlock = sliceBlock(body, '食疗方案', dietLabels.filter(x => x !== '食疗方案'));
  const recipe = recipeBlock; // 可能为空
  const recipes = parsePairs(recipeBlock); // e.g. [{label:'蔬菜类', text:'...'}, ...]

  const tabooBlock = sliceBlock(body, '饮食禁忌', dietLabels.filter(x => x !== '饮食禁忌'));
  const taboo = parsePairs(tabooBlock);
  const tabooLines = taboo.map(i => `${i.label}：${i.text}`);

  return {
    rule,
    foods, foodsLines,
    recipe, recipes,
    taboo, tabooLines, tabooBlock
  };
}

function parseSport(body) {
  const sportLabels = ['原则', '推荐运动', '注'];
  const rule = sliceBlock(body, '原则', sportLabels.filter(x => x !== '原则')).replace(/\n+/g, ' ').trim();
  const recText = sliceBlock(body, '推荐运动', sportLabels.filter(x => x !== '推荐运动')).replace(/\n+/g, ' ').trim();
  const tags = splitList(recText.replace(/^(?:为|是)?/, '').replace(/^：/, ''));
  const note = sliceBlock(body, '注', sportLabels.filter(x => x !== '注')).replace(/\n+/g, ' ').trim();
  return {rule, tags, note};
}

function parseLifestyle(body) {
  // 起居调养：三条
  const items = parsePairs(body);
  const lines = items.map(i => `${i.label}：${i.text}`);
  return {items, lines};
}

function parseEmotion(body) {
  // 情志调养：两条
  const items = parsePairs(body);
  const lines = items.map(i => `${i.label}：${i.text}`);
  return {items, lines};
}

function parseSummary(body) {
  return body.replace(/\n+/g, ' ').trim();
}

function parseModel(textRaw) {
  const text = normalize(textRaw);
  const sections = splitSections(text, ['饮食调养', '运动保健', '起居调养', '情志调养', '总结']);

  const map = {};
  sections.forEach(sec => map[sec.title] = sec.body);

  const diet = parseDiet(map['饮食调养'] || '');
  const sport = parseSport(map['运动保健'] || '');
  const lifestyle = parseLifestyle(map['起居调养'] || '');
  const emotion = parseEmotion(map['情志调养'] || '');
  const summary = parseSummary(map['总结'] || '');

  // 视图友好对象：可直接对接你现有的三个卡片
  const viewModel = {
    diet: {
      rule: diet.rule,
      panels: [
        {key: 'foods', title: '推荐食物', color: 'aqua', lines: diet.foodsLines},
        // 如果没有“食疗方案”，可以忽略该面板；仍保留字段做兼容
        ...(diet.recipe ? [{key: 'recipe', title: '食疗方案', color: 'peach', text: diet.recipe}] : []),
        {key: 'taboo', title: '饮食禁忌', color: 'pink', lines: diet.tabooLines}
      ]
    },
    sport: {
      rule: sport.rule,
      tags: sport.tags, // ['游泳','快走','慢跑','球类运动']
      note: sport.note   // “注：…”内容
    },
    emotionLifestyle: {
      // 你的第三张卡片是“情志起居调养”，包含两个面板
      emotionPanel: {title: '情志调养', color: 'blue', lines: emotion.lines},
      lifestylePanel: {title: '起居调养', color: 'lavender', lines: lifestyle.lines}
    },
    summary // 备用：如需在页面底部展示总结
  };

  return {diet, sport, lifestyle, emotion, summary, viewModel};
}

export default {
  name: 'NewHealthServices',
  components: {view_bottom},
  data() {
    return {
      constitution: {
        syndrome: '',
        explain: '',
        health: '',
        meridians: '',
        diet: '',
        sport: '',
        emotion: '',
        lifestyle: ''
      },
      meridian: null,
      icons: {diet: '', sport: '', emotion: '', warn: ''},
      bodyfluidNames: '',
      bodyfluidDescribe: '',
      colorOfMossNames: '',
      colorOfMossDescribe: '',
      colorOfTongueNames: '',
      colorOfTongueDescribe: '',
      mossNames: '',
      mossDescribe: '',
      shapeOfTongueNames: '',
      shapeOfTongueDescribe: '',
      veinNames: '',
      veinDescribe: '',
      constitutionNames: '',
      constitutionDescribe: '',
      singleConfigName: '',
      ossOriImgUrl: '',
      ossSplitImgUrl: '',
      ossSplitBackImgUrl: '',
      diagnostic_results: '',
      br: '',
      loading: false,
      finished: true,
      sports_health_care: [{
        message: '',
        items: [{
          name: '',
          photo: '',
          desc: ''
        }]
      }],
      diet_rehabilitation: [{
        message: '',
        items: [{
          name: '',
          photo: '',
          desc: ''
        }]
      }],
      predisposition: [{
        message: '',
        items: [{
          name: '',
          photo: '',
          desc: ''
        }]
      }],
      massage_health_care: [
        {
          message: '',
          items: [{
            name: '',
            photo: '',
            desc: ''
          }]
        }
      ],
      main_performance: [
        {
          message: '',
          items: [{
            name: '',
            photo: '',
            desc: ''
          }]
        }
      ],
      occur_reason: [
        {
          message: '',
          items: [{
            name: '',
            photo: '',
            desc: ''
          }]
        }
      ],
      drug_health_care: [
        {
          message: '',
          items: [{
            name: '',
            photo: '',
            desc: ''
          }]
        }
      ],
      recuperates: [
        {
          message: '',
          items: [{
            name: '',
            photo: '',
            desc: ''
          }]
        }
      ],
    }
  },
  created() {
    // document.title = '舌诊评估'
    console.log(this.$route.query)
    this.id = this.$route.query.id
    this.getcode(this.id)
  },
  methods: {
    getcode(id) {
      let url = `${this.baseUrl}/app/details?id=${id}`
      this.br = '<br/>'
      axios.post(url)
          .then((result) => {
            console.log(result)
            let details = result.data.userDetails
            this.bodyfluidNames = details.bodyfluidnames
            this.bodyfluidDescribe = details.bodyfluiddescribe
            this.colorOfMossNames = details.colorofmossnames
            this.colorOfMossDescribe = details.colorofmossdescribe
            this.colorOfTongueNames = details.coloroftonguenames
            this.colorOfTongueDescribe = details.coloroftonguedescribe
            this.colorOfTongueDescribe = details.coloroftonguedescribe
            this.mossNames = details.mossnames
            this.mossDescribe = details.mossdescribe
            this.shapeOfTongueNames = details.shapeoftonguenames
            this.shapeOfTongueDescribe = details.shapeoftonguedescribe
            this.shapeOfTongueDescribe = details.shapeoftonguedescribe
            this.veinNames = details.veinnames
            this.veinDescribe = details.veindescribe
            this.constitutionNames = details.constitutionnames
            this.constitutionDescribe = details.constitutiondescribe
            this.singleConfigName = details.singleconfigname
            this.ossOriImgUrl = details.ossoriimgurl
            this.ossSplitImgUrl = details.osssplitimgurl
            this.ossSplitBackImgUrl = details.osssplitbackimgurl
            let json = JSON.parse(details.treatplanjson)
            console.log(json)
            this.diagnostic_results = json[0] && json[0].diagnostic_results
            if (this.diagnostic_results == null || this.diagnostic_results == '') {
              this.diagnostic_results = this.singleConfigName || this.constitutionNames
            }
            console.error(this.diagnostic_results)
            this.getConstitution(this.diagnostic_results)
            this.sports_health_care = json[0] && json[0].sports_health_care
            this.diet_rehabilitation = json[0] && json[0].diet_rehabilitation
            this.predisposition = json[0] && json[0].predisposition
            this.massage_health_care = json[0] && json[0].massage_health_care
            if (this.massage_health_care == null) {
              this.massage_health_care = []
              if (json.massageHealthCare) {
                if (json.massageHealthCare.statusStatement) {
                  this.massage_health_care.push({message: json.massageHealthCare.statusStatement})
                }
                if (json.massageHealthCare.acupointSelection) {
                  this.massage_health_care.push({message: json.massageHealthCare.acupointSelection})
                }
                if (json.massageHealthCare.method) {
                  this.massage_health_care.push({message: json.massageHealthCare.method})
                }
                if (json.massageHealthCare.acupoints) {
                  for (let acupoint of json.massageHealthCare.acupoints) {
                    this.massage_health_care.push({
                      bottom: acupoint.name,
                      photo: acupoint.imageUrl,
                      message: acupoint.genealogy,
                      desc: `${acupoint.position || ''}<br> ${acupoint.findingAcupointMethod || ''}`,
                    })
                  }
                }
                this.massage_health_care.push({message: `以上方案仅做参考，具体操作建议进一步咨询专业中医师（医疗行为需要由专业中医师进行操作）。`})
              }
            }
            this.main_performance = json[0] && json[0].main_performance
            this.occur_reason = json[0] && json[0].occur_reason
            this.drug_health_care = json[0] && json[0].drug_health_care
            this.recuperates = json[0] && json[0].recuperates
          }).catch(error => {
        //this.$router.replace("error")
      })
    },
    getConstitution(name) {
      console.error(this)
      this.$http.getConstitution(name).then(({data}) => {
        console.error('getConstitution', data)

        this.constitution = {...this.constitution, ...data}
// 最终解析输出
        const parsed = parseModel(data.health);
        this.constitution = {...this.constitution, ...parsed}
        console.error(this.constitution)
      })
    },
    getMeridian(name) {
      this.$http.getMeridian(name).then(data => {
        console.error('getMeridian', data)
      })
    }
  },
  /* ===== 优化补充：新增 mounted 钩子，不改动原有代码 ===== */
  mounted() {
    // 为页面内所有图片启用懒加载与异步解码（不修改原模板）
    try {
      const imgs = this.$el.querySelectorAll('img');
      imgs.forEach(img => {
        if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
        if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      });
    } catch (e) {
    }

    // 在生产环境降低 console 输出的开销（不修改原有 console 调用）
    try {
      if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production') {
        const noop = () => {
        };
        ['log', 'error', 'warn', 'info', 'debug'].forEach(k => {
          if (typeof console[k] === 'function') {
            console[k] = noop;
          }
        });
      }
    } catch (e) {
    }
  }
}
</script>

<style scoped>
.pl30 {
  padding-left: 30px;
}

.fz28 {
  color: #000000;
  font-size: 30px;
}

.fz20 {
  font-size: 20px;
  color: #999999;
}

.p15 {
  padding: 10px;
}

.Recuperation {
  display: flex;
  align-items: center;
  margin-top: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: rgba(245, 245, 245, 1);
  border-radius: 15px;
}

.Recuperation > img {
  width: 120px;
  height: 120px;
  display: block;
  border-radius: 25px;
}

.explain {
  font-size: 28px;
  color: rgba(56, 56, 56, 1);
  padding: 20px 0;
}

.glossoscopyimg > img {
  width: 160px;
  height: 160px;
  display: block;
  border-radius: 50%;
}

.col9 {
  color: #999999;
}

.df {
  display: flex;
}

.jub {
  justify-content: space-between;
}

.pt30 {
  padding-top: 30px;
}

.coltt {
  color: #e9c7a0;
}

.al {
  align-items: center;
}

.fz25 {
  font-size: 25px;
}

.fz24 {
  font-size: 26px;
  color: #999999;
  line-height: 45px;
  padding-top: 30px;
}

.glossoscopytitle_two {
  font-size: 40px;
  color: #e9c7a0;
  font-weight: 650;
  text-align: center;
  /* border-bottom: 6px solid #e9c7a0; */
  /* width: 50px; */
  margin: 0 auto 30px auto;
  /* padding-bottom: 45px; */
}

.glossoscopytitle_one {
  display: flex;
  align-items: center;
}

.glossoscopytex {
  width: 30px;
  height: 30px;
  /* background-color: #000000; */
  /* border-radius: 50%; */
  display: block;
  margin-right: 10px;
}

.glossoscopyList {
  background-color: #ffffff;
  border-radius: 25px;
  padding: 30px;
}

.glossoscopytitle {
  font-size: 26px;
  color: #000000;
  font-weight: 650;
}

.glossoscopy {
  padding: 0.4rem;
  background: #e9c7a0;
}

/deep/ .van-nav-bar .van-icon {
  color: black !important;
}

.assessment > img {
  width: 160px;
  height: 160px;
  display: block;
  border-radius: 50%;
}

.assessment {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.commentsItem {
  display: flex;
  justify-content: space-between;
}

.diagnostic_results_view {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 40px;
}

.diagnostic_results_view span {
  padding: 8px 24px;
  border-radius: 38px;
  background: rgba(217, 250, 248, 1);

  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #e9c7a0;
  vertical-align: top;
}

/* 顶部：左对齐、白底徽章 */
.header {
  margin: -12vh 3vw 1vh;
}

.header-title {
  color: #ffffff;
  font-size: 40px;
  font-weight: 600;
  line-height: 1.2;
  text-align: left;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  margin-bottom: 6px;
}

.badge {
  display: inline-block;
  padding: 15px;
  border-radius: 999px;
  font-size: 25px;
}

.badge-white {
  background: #ffffff;
  color: #8a5b2a;
  border: 1px solid rgba(255, 255, 255, 0.8);
}

/* 主体容器 */
.container {
  width: 100%;
  display: grid;
  grid-auto-rows: min-content;
  gap: 10px;
  box-sizing: border-box;
}

/* 卡片 */
.card {
  background: #ffffff;
  border-radius: 25px;
  box-shadow: 0 8px 18px rgba(128, 67, 26, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.7);
  overflow: hidden;
}

/* 头部（默认：图标上、标题下；右侧为“原则”） */
.card-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px 6px;
  gap: 8px;
}

.hd-left {
  display: flex;
  flex-direction: column; /* 默认上下 */
  align-items: center;
  gap: 6px;
}

.icon {
  width: 60px;
  height: 60px;
  /*border-radius: 6px;*/
  /*background: #ffeae3; !* 占位色 *!*/
  object-fit: contain;
}

.card-title {
  color: #2f2f2f;
  font-size: 30px;
  font-weight: 600;
  line-height: 1;
}

/* “原则”备注气泡 */
.rule-bubble {
  flex: 1;
  margin-left: 8px;
  background: #f5f5f7;
  border: 1px solid #eeeeee;
  color: #6b6b6b;
  font-size: 22px;
  line-height: 1.6;
  border-radius: 8px;
  padding: 8px 10px;
}

/* 情志起居调养：左右排列、无气泡时靠左 */
.hd-left--row {
  flex-direction: row; /* 左右排列 */
  align-items: center;
  gap: 8px;
}

.card-hd--no-bubble {
  justify-content: flex-start; /* 无右侧备注时靠左 */
  padding-bottom: 8px;
}

/* 正文 */
.card-bd {
  padding: 8px 12px 12px;
}

/* 面板与副标题色系 */
.panel {
  position: relative;
  border-radius: 10px;
  padding: 10px 12px;
  border: 1px solid transparent;
}

.panel + .panel {
  margin-top: 8px;
}

.panel-title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 6px;
}

.panel-text {
  font-size: 26px;
  line-height: 2;
  color: #4a4a4a;
}

.panel-aqua {
  background: #e9fbff;
  border-color: #d6f4fb;
}

.panel-aqua .panel-title {
  color: #1aa3b0;
}

.panel-peach {
  background: #fff3e5;
  border-color: #ffe1c4;
}

.panel-peach .panel-title {
  color: #e48a3a;
}

.panel-pink {
  background: #fff2f4;
  border-color: #ffdbe0;
}

.panel-pink .panel-title {
  color: #e15a6c;
}

.panel-blue {
  background: #ecf7ff;
  border-color: #d8ecff;
}

.panel-blue .panel-title {
  color: #3aa1ff;
}

.panel-lavender {
  background: #f4efff;
  border-color: #e4ddff;
}

.panel-lavender .panel-title {
  color: #7f69d9;
}

/* 警示图标 */
.panel-warning .warn {
  position: absolute;
  right: 10px;
  bottom: 10px;
  object-fit: contain;
  width: 60px;
  height: 60px;
}

/* 运动标签与注释 */
.sub-title {
  font-size: 26px;
  font-weight: 600;
  color: #3a3a3a;
  margin: 12px 0 8px;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.tag {
  font-size: 26px;
  color: #ffffff;
  background: #1db7aa;
  border-radius: 16px;
  padding: 10px;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.04) inset;
}

.note {
  margin-top: 16px;
  font-size: 22px;
  color: #7a7a7a;
}
</style>

<!-- ===== 优化补充样式：新增的第二个 style，不改动上面的原样式 ===== -->
<style scoped>
/* 顶部大图移除混合与滤镜，降低滚动绘制开销（用选择器匹配资源名，避免修改模板） */
img[src$="health_bg.png"] {
  mix-blend-mode: normal !important;
  filter: none !important;
  opacity: 0.9;
  will-change: opacity;
  backface-visibility: hidden;
}

/* 降低阴影强度以减少绘制成本（覆盖原有 .card 阴影） */
.card {
  box-shadow: 0 4px 10px rgba(128, 67, 26, 0.08);
}

/* 离屏内容惰性渲染，显著减少样式/布局/绘制开销 */
.card,
.glossoscopyList {
  content-visibility: auto;
  contain-intrinsic-size: 500px;
}

/* 减少文本阴影开销（覆盖 header 标题的 text-shadow） */
.header-title {
  text-shadow: none;
}

/* 用更轻的布局代替 grid，降低布局计算成本（覆盖 .container） */
.container {
  display: flex;
  flex-direction: column;
}

/* 顶部 health_bg.png 不再吃事件，滚轮/手势能传递到页面滚动 */
.health_bg {
  pointer-events: none; /* 关键：不拦截鼠标/触摸事件 */
  -webkit-user-drag: none; /* iOS/Safari 避免拖拽干扰 */
  user-select: none;

  /* 同时移除混合/滤镜，降低绘制成本（顺便优化卡顿） */
  position: absolute;
  right: 0;
  object-fit: contain;
  width: 80vw;
  filter: opacity(0.8);
  mix-blend-mode: overlay;
  opacity: 1;
}
</style>
